import React from 'react';
import type { WebhookSubscription } from '../../../types/admin';

interface WebhookPanelProps {
  subscriptions: WebhookSubscription[];
}

function expiryStatus(expirationStr: string): { label: string; color: string; bg: string } {
  const expiry = new Date(expirationStr);
  const now = Date.now();
  const hoursLeft = (expiry.getTime() - now) / (1000 * 60 * 60);

  if (hoursLeft <= 0) return { label: 'EXPIRED', color: '#DC3545', bg: 'rgba(220,53,69,0.1)' };
  if (hoursLeft < 12) return { label: formatCountdown(hoursLeft), color: '#FFC107', bg: 'rgba(255,193,7,0.1)' };
  return { label: formatCountdown(hoursLeft), color: '#28A745', bg: 'rgba(40,167,69,0.1)' };
}

function formatCountdown(hours: number): string {
  if (hours <= 0) return 'EXPIRED';
  const d = Math.floor(hours / 24);
  const h = Math.floor(hours % 24);
  return d > 0 ? `${d}d ${h}h` : `${h}h`;
}

function formatExpiry(iso: string): string {
  const d = new Date(iso);
  return d.toLocaleString('en-US', {
    month: 'numeric',
    day: 'numeric',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    timeZoneName: 'short',
  });
}

function friendlyLabel(sub: WebhookSubscription): string {
  if (sub.label.includes('doyleintranet')) return 'DoyleIntranet KB';
  if (sub.label.includes('remoteprogramming')) return 'RemoteProgramming KB';
  return sub.label;
}

export const WebhookPanel: React.FC<WebhookPanelProps> = ({ subscriptions }) => {
  if (subscriptions.length === 0) {
    return (
      <div className="adm-card">
        <div className="adm-card-title">Graph Webhook Subscriptions</div>
        <p className="adm-muted">No active subscriptions.</p>
      </div>
    );
  }

  return (
    <div className="adm-card">
      <div className="adm-card-title">Graph Webhook Subscriptions</div>
      <table className="adm-table" style={{ marginTop: 8 }}>
        <thead>
          <tr>
            <th>Site</th>
            <th>Subscription ID</th>
            <th>Expires</th>
            <th>TTL</th>
            <th>Status</th>
          </tr>
        </thead>
        <tbody>
          {subscriptions.map((sub) => {
            const es = expiryStatus(sub.expiration);
            return (
              <tr key={sub.subscription_id}>
                <td style={{ fontWeight: 600 }}>{friendlyLabel(sub)}</td>
                <td className="adm-mono" style={{ fontSize: '0.7rem' }}>
                  {sub.subscription_id.slice(0, 8)}
                </td>
                <td className="adm-mono" style={{ fontSize: '0.72rem' }}>
                  {formatExpiry(sub.expiration)}
                </td>
                <td>
                  <span
                    className="adm-mono"
                    style={{
                      color: es.color,
                      fontWeight: 600,
                      fontSize: '0.72rem',
                    }}
                  >
                    {es.label}
                  </span>
                </td>
                <td>
                  <span
                    style={{
                      display: 'inline-block',
                      width: 8,
                      height: 8,
                      borderRadius: '50%',
                      background: es.color,
                    }}
                  />
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};
